import { render, staticRenderFns } from "./result-info.vue?vue&type=template&id=98f0230e&scoped=true&"
import script from "./result-info.vue?vue&type=script&lang=js&"
export * from "./result-info.vue?vue&type=script&lang=js&"
import style0 from "./result-info.vue?vue&type=style&index=0&id=98f0230e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f0230e",
  null
  
)

export default component.exports